import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import Root from './router';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from "./auth/AuthContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();